<div class="container-requirements">
    <button
        type="button"
        class="container-requirements__btn w-100"
        [ngClass]="{ opened: opened }"
        (click)="toggle()"
        [attr.aria-expanded]="opened"
    >
        <span class="container-requirements__heading">
            <svg
                class="container-requirements__icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <circle cx="12" cy="12" r="11" fill="#8C4B9F" />
                <path
                    d="M12 6.2a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Zm-1.1 4.2h2.2v7.4h-2.2Z"
                    fill="#ffffff"
                />
            </svg>
            {{ 'fe_step4_requirements_h3_title' | translate }}
        </span>
        <svg
            class="container-requirements__chevron"
            viewBox="0 0 13.37 13.37"
            aria-hidden="true"
        >
            <path
                d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
                fill="#8C4B9F"
            />
        </svg>
    </button>
    <div
        class="container-requirements__collapse"
        [ngClass]="{ opened: opened }"
    >
        <ul class="container-requirements__list">
            <li>{{ 'fe_step4_requirements_li_first' | translate }}</li>
            <li>{{ 'fe_step4_requirements_li_second' | translate }}</li>
            <li>{{ 'fe_step4_requirements_li_third' | translate }}</li>
            <li>
                {{ 'fe_step4_requirements_li_fourth' | translate }}
                <a
                    class="container-requirements__link"
                    href="#rental-policies"
                    (click)="scrollToPolicies($event)"
                    >{{ 'fe_step4_requirements_a_policy' | translate }}</a
                >.
            </li>
        </ul>
    </div>
</div>
